import { getGrpcPromise } from '@monorepo/grpc';
import { FastDealService } from '@spilca/order_ts/v1/order_web/fast_deal_web_pb_service';
import { ListFastDealPaymentConditionRequest } from '@spilca/order_ts/v1/order/model_fast_deal_pb';
import { fastDealsFilterConstructor } from '@monorepo/fast-deals';

const getFastDealsPaymentConditions = (d: any) => {
  const getPaymentConditions = getGrpcPromise(
    FastDealService.ListFastDealPaymentCondition
  );
  const [, params] = d.queryKey;
  const dealFilter = fastDealsFilterConstructor(params, d.active);
  const request = new ListFastDealPaymentConditionRequest();
  request.setFilter(dealFilter);
  return getPaymentConditions(request);
};

export default getFastDealsPaymentConditions;
